// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__YJaEA"};
module.exports.__checksum = "26a43139e57e"
